/**
 * Feature Flag for PostgreSQL Migration (Admin Panel)
 *
 * Returns true when the admin panel should use the PostgreSQL backend API
 * instead of the legacy direct datastore/search access layer.
 *
 * Uses REACT_APP_ prefix (CRA convention).
 */
export const usePostgreSQL = (): boolean => {
  return true
}
